export default {"src":"/_next/static/media/tableEdit.004c07d1.svg","height":14,"width":14};